import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../styleSheet/main/components/TODO/createForTODO/createForTODO.css"; // Importujemy styl
import deleteButtonIcon from "./../../media/delete-button.svg"; // Import ikony
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { pl } from "date-fns/locale";
import httpClient from "../../services/httpClient";

const CreateForTODO = ({ onClose, onCreate, userName, userId }) => {
  const { t } = useTranslation();
  const [newTaskText, setNewTaskText] = useState("");
  const [newTaskDate, setNewTaskDate] = useState(null); // Przechowywanie daty w newTaskDate
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  console.log("CreateForTODO props:", { userName, userId });

  // Zmieniona funkcja ustawiająca datę
  const handleDateChange = (date) => {
    setNewTaskDate(date); // Aktualizacja stanu daty
  };

  const handleCreateTask = async () => {
    console.log("handleCreateTask called", {
      newTaskText,
      newTaskDate,
      userId,
    });

    if (!userId) {
      console.error("userId is missing!");
      setErrors({ submit: "Błąd: brak ID użytkownika." });
      return;
    }

    if (newTaskText && newTaskDate) {
      setIsSubmitting(true);
      try {
        const taskData = {
          title: newTaskText,
          dueDate: newTaskDate.toISOString().slice(0, 10), // Format: YYYY-MM-DD
          assigneeId: userId,
        };

        console.log("Sending task data:", taskData);

        const response = await httpClient.post("/ToDoTasks/assign", taskData, {
          withAuth: true,
        });

        console.log("Task created successfully:", response.data);

        // Przekaż utworzone zadanie do rodzica
        const newTask = {
          text: newTaskText,
          date: newTaskDate.toISOString().slice(0, 10),
          ...response.data,
        };
        onCreate(newTask);
      } catch (error) {
        console.error("Error creating task:", error);
        setErrors({ submit: "Nie udało się utworzyć zadania." });
        setIsSubmitting(false);
      }
    }
  };

  // Walidacja formularza - obydwa pola muszą być wypełnione
  const isFormValid = newTaskText !== "" && newTaskDate !== null;

  // Funkcja pomocnicza do wyodrębniania imienia z pełnej nazwy
  const getFirstName = (fullName) => {
    return fullName.split(" ")[0];
  };

  const firstName = getFirstName(userName);

  return (
    <div className="create-task-overlay">
      <div className="create-task-content">
        <img
          src={deleteButtonIcon}
          alt="Zamknij"
          className="close-button"
          onClick={onClose}
        />
        <p>{t("todo.createNewForUser", { name: userName })}</p>
        <div className="form-group">
          <label htmlFor="newTaskText">{t("todo.label.content")}</label>
          <input
            type="text"
            id="newTaskText"
            value={newTaskText}
            onChange={(e) => setNewTaskText(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="newTaskDate">{t("todo.label.date")}</label>
          <DatePicker
            selected={newTaskDate} // Używamy newTaskDate jako stanu
            onChange={handleDateChange}
            dateFormat="dd-MM-yyyy"
            locale={pl}
            minDate={new Date()}
          />
          {errors.newTaskDate && (
            <span className="error-message">{errors.newTaskDate}</span>
          )}
        </div>
        {errors.submit && <div className="error-message">{errors.submit}</div>}
        <button
          onClick={handleCreateTask}
          disabled={!isFormValid || isSubmitting}
        >
          {isSubmitting
            ? t("todo.saving")
            : t("todo.saveTaskFor", { name: firstName })}
        </button>
      </div>
    </div>
  );
};

export default CreateForTODO;
